<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<div class="grid-two">
  <mat-card class="block">
    <h2>{{ editingId ? 'Edit judge' : 'Add judge' }}</h2>
    <form class="form-grid" [formGroup]="form" (ngSubmit)="save()">
      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Qualification / designation + company</mat-label>
        <input matInput formControlName="qualification" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="full">
        <mat-label>Summary</mat-label>
        <textarea matInput rows="3" formControlName="summary"></textarea>
      </mat-form-field>
      <app-image-url-field
        class="full"
        [challengeId]="id"
        controlName="photoUrl"
        label="Photo"
        placeholderType="judge"
        [displayUrl]="editingDisplayUrl"
      ></app-image-url-field>
      <mat-form-field appearance="outline">
        <mat-label>Sort order</mat-label>
        <input matInput type="number" formControlName="sortOrder" />
      </mat-form-field>
      <div class="actions">
        <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid || busy">Save</button>
        <button mat-button type="button" (click)="reset()" [disabled]="busy">Clear</button>
      </div>
    </form>
  </mat-card>

  <mat-card class="block">
    <h2>Judges</h2>
    <div class="list" *ngIf="judges.length; else empty">
      <div class="row" *ngFor="let j of judges">
        <div class="row-main">
          <img class="thumb" [src]="judgeImageSrc(j)" [alt]="j.name" />
          <div>
          <strong>{{ j.name }}</strong>
          <div class="meta">{{ j.qualification || '—' }} · order {{ j.sortOrder }}</div>
          <div class="meta" *ngIf="j.summary">{{ j.summary }}</div>
          </div>
        </div>
        <div class="actions">
          <button mat-button type="button" (click)="edit(j)">Edit</button>
          <button mat-button type="button" (click)="remove(j.id)">Delete</button>
        </div>
      </div>
    </div>
    <ng-template #empty><p class="empty">No judges yet. Without judges, the AI contest score is final.</p></ng-template>
  </mat-card>
</div>